import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import "./services/i18n";

// Redux 
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './components/redux/reducers/index'

import App from './App';

import './css/bootstrap.css';
import './css/style.css';
import './css/todo.css';
import './css/pages/error.css';
import 'flag-icons/css/flag-icons.min.css';

const store = createStore(rootReducer, composeWithDevTools())


const loadingMarkup = (
  <div className='py-4 text-center'>
    <h2>Loading..</h2>
  </div>

)
ReactDOM.render(
  <Suspense fallback={loadingMarkup}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </Suspense>,

  document.getElementById('root')
);

